/**
 * @fileoverview POST handler for the "/comments/:target/threads/:thread_id/comments" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { mutationCacheKeys } from "./constants";
import type { AppendAppGroupToUrl, CreateCommentProps, CreateCommentResult } from "./types";

export const createComment = reactQueryMutationAdapter(
  mutationCacheKeys,
  (props: AppendAppGroupToUrl<CreateCommentProps>): Promise<CreateCommentResult> => {
    return fetch(
      `/comments/${props.target}/threads/${props.threadId}/comments?app_group_id=${props.appGroupId}`,
      "POST",
      {
        message: props.message,
      }
    );
  }
);
